import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "collection-tabs" }
const _hoisted_2 = ["title", "onClick", "onKeydown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_ontos_shell_menu = _resolveComponent("ontos-shell-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$vuetify.display.xs)
      ? (_openBlock(), _createBlock(_component_ontos_shell_menu, {
          key: 0,
          label: _ctx.$tt('collection'),
          value: _ctx.currentLabel
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ideas, (idea) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: idea.alias,
                to: _ctx.routeOf(idea),
                title: _ctx.labelOf(idea)
              }, null, 8, ["to", "title"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["label", "value"]))
      : (_openBlock(), _createBlock(_component_v_tabs, {
          key: 1,
          "model-value": _ctx.currentAlias,
          mandatory: "",
          "show-arrows": "",
          density: "compact"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ideas, (idea) => {
              return (_openBlock(), _createBlock(_component_v_tab, {
                key: idea.alias,
                value: idea.alias,
                class: "collection-tab",
                onClick: ($event: any) => (_ctx.go(idea))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.labelOf(idea)) + " ", 1),
                  (_ctx.creatable(idea))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "collection-tab-create",
                        role: "button",
                        tabindex: "0",
                        title: _ctx.$tt('instance-create', {collection: idea.name}),
                        onClick: _withModifiers(($event: any) => (_ctx.create(idea)), ["stop"]),
                        onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.create(idea)), ["stop","prevent"]), ["enter"])
                      }, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("mdi-plus", -1)
                          ]))]),
                          _: 1
                        })
                      ], 40, _hoisted_2))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["value", "onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model-value"]))
  ]))
}